<template>
    <div>
        <Wp_nav_bar title="我的粉丝"></Wp_nav_bar>
        <van-tabs v-model="active" sticky title-active-color="#ee0a24">
            <van-tab>
                <div slot="title"><h3>普通会员</h3></div>

                <Wp_mini_member_fans_model memberType="-1"></Wp_mini_member_fans_model>
            </van-tab>
            <van-tab>
                <div slot="title"><h3>超级会员</h3></div>
                <Wp_mini_member_fans_model memberType="0"></Wp_mini_member_fans_model>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
    import Wp_mini_member_fans_model from "./Wp_mini_member_fans_model";
    import Wp_nav_bar from "../custom/Wp_nav_bar";
    export default {
        name: "Wp_mini_member_fans",
        components: {Wp_nav_bar, Wp_mini_member_fans_model},
        data(){
            return{
                //上拉加载的临时list
                list: [],
                //上拉加载状态结束
                loading: false,
                //数据全部加载完成的状态
                finished: false,

                //请求数据页码
                page_index: 1,
                //一次页面请求多少数据
                page_size: 20,

                active: 0,
            }
        },
    }
</script>

<style scoped>

</style>